import { inject } from 'vue';
export function useRedirect() {
    const redirectPathAfterVehicleSelection = inject('redirectToPageAfterVehicleSelection', '');
    // Function to check if we should redirect
    function shouldRedirectAfterVehicleSelection() {
        return !!redirectPathAfterVehicleSelection &&
            window.location.pathname !== redirectPathAfterVehicleSelection;
    }
    // Optional: function to perform the redirect
    function redirect() {
        if (shouldRedirectAfterVehicleSelection()) {
            window.location.href = redirectPathAfterVehicleSelection;
        }
    }
    return {
        redirectPathAfterVehicleSelection,
        shouldRedirectAfterVehicleSelection,
        redirect
    };
}
